import React from 'react'
import background from '../../assets/Michelle_Background.jpg'
import imageRight from '../../assets/basketball.png'

const MichelleProfilePage = () => {
    const backgroundImage = {
        display: 'flex',
        backgroundImage: `url(${background})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        height: '100vh',
        paddingLeft: '100px', 
      };
    
      const wordStyle = {
        flex: 1,
        padding: '20px',
        color: 'white',
        fontFamily: 'Times New Roman, serif',
      };
    
      const imageRightStyle = {
        width: '50%', 
        background: `url(${imageRight}) no-repeat center center`, 
        backgroundSize: 'cover',
      };
    
      return (
        <div style={backgroundImage}>
          <div style={wordStyle}>
            <h1> Michelle Ye </h1> 
            <p>
                Hi, My name is Michelle Ye, a fourth year Computer Science Student at University of Buffalo. I have many hobbies, the top 3 has to be basketball, video games, and puzzle. Whats yours?
            </p>
            <br></br>
            <h3>Favor Video Games:</h3>
            <p>
                League of Legends<br></br>
                Minecraft<br></br>
                Tomb Raider<br></br>
                Civilization VI
            </p>
          
          </div>
          <div style={imageRightStyle}></div>
        </div>
      );
}
export default MichelleProfilePage;